import {
    ableProps,
    ablePropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'hideTitle',
        label: '是否隐藏标题文字',
        type: 'boolean',
    },
    {
        key: 'hint',
        label: '提示文字',
        type: 'string',
    },
    {
        key: 'text',
        label: '举报节点文字',
        type: 'string',
    },
    {
        key: 'children',
        label: '子组件列表',
        type: 'array',
        config: {
            label: '子组件列表',
            output: 'children',
            component: 'array',
            props: {
                hint: '为使用方便请勿设置过多层嵌套',
                min: 0,
                max: 0,
                sortable: true,
                singleItem: {
                    label: '子组件',
                    output: '',
                    component: 'form-config',
                },
            },
        },
    },
];

export const init = () => ({
    ...ablePropsInit,
    hideTitle: true,
    hint: '',
    text: '',
    children: [],
});

export const name = '表单容器';

export const component = 'mobile-general-form-container';

export const events = [
    ...baseEvents,
];
